import { objectFlip } from '../utils/functions';

export const WATSON_DIALOG_NEXT_STEP_SELECTOR = {
  BODY: 'Sempre, independente da condição',
  CONDITION: 'Sempre que a condição for reconhecida',
  USER_INPUT: 'Depois da mensagem do usuário, sempre que a condição for reconhecida',
};

export const WATSON_DIALOG_NEXT_STEP_BEHAVIOR = {
  JUMP_TO: 'JUMP_TO',
};

const WATSON_DIALOG_NEXT_STEP_SELECTOR_AS_OUTPUT = objectFlip(WATSON_DIALOG_NEXT_STEP_SELECTOR);

export default class DialogNextStepDTO {
  constructor(nextStep) {
    this.dialog = nextStep.dialogNode || nextStep.dialog;
    this.selector = nextStep.selector;
  }

  asInput = () => {
    this.selector = WATSON_DIALOG_NEXT_STEP_SELECTOR[this.selector] || null;
    return this;
  }

  asOutput = () => {
    if (!this.selector) return null;
    this.behavior = WATSON_DIALOG_NEXT_STEP_BEHAVIOR.JUMP_TO;
    this.selector = WATSON_DIALOG_NEXT_STEP_SELECTOR_AS_OUTPUT[this.selector];
    this.dialogNode = `${this.dialog}`;
    delete this.dialog;
    return this;
  }
}
